export default {
  approveNewRpc: '.confirmation-warning-modal__content .mm-button-primary--type-danger',
  rejectNewRpc: '.confirmation-warning-modal__content .mm-button-secondary'
}
